/**
 * Removes all falsey values (null, undefined, false, 0, '', NaN) from an object.
 * @param {Record<string, unknown> | undefined} obj - The source object to filter
 * @returns {Record<string, unknown>} A new object containing only truthy values
 */
export function excludeFalseyValues(
  obj: Record<string, unknown> | undefined,
): Record<string, unknown> {
  return Object.fromEntries(Object.entries(obj || {}).filter(([_, value]) => value))
}
